import { Cookies } from 'react-cookie';
import { IS_COOKIE_HTTPS_ONLY } from '../../../../../config/index';
import { isEmptyObject } from '../../../../../core/util/object';
import { isEmptyString } from '../../../../../core/util/string';

const COOKIE_NAME = 'ibe'; // insurance benefits engagement
const FEEDBACK_NEGATIVE = 'down';
const FEEDBACK_POSITIVE = 'up';
const YEAR_IN_SECONDS = 365 * 24 * 60 * 60;

const generateCookieName = (userProfileId: any) => `${COOKIE_NAME}-${userProfileId}`;

const setInsuranceFeedbackGiven = (tileId: any, userProfileId: any, feedbackType: any) => {
  try {
    const cookies = new Cookies();
    const feedbackHistory = cookies.get(generateCookieName(userProfileId));
    const updated = feedbackHistory ? { ...feedbackHistory } : {};
    updated[tileId] = feedbackType;
    return cookies.set(generateCookieName(userProfileId), updated, {
      path: '/',
      secure: IS_COOKIE_HTTPS_ONLY,
      maxAge: 100 * YEAR_IN_SECONDS,
    });
  } catch (e) {
    return false;
  }
};

const getInsuranceFeedback = (tileId: any, userProfileId: any) => {
  if (isEmptyString(userProfileId) || isEmptyString(tileId)) return null;

  const feedbackHistory = new Cookies().get(generateCookieName(userProfileId));
  if (isEmptyObject(feedbackHistory) || !feedbackHistory[tileId]) {
    return null;
  }

  return feedbackHistory[tileId];
};

export { setInsuranceFeedbackGiven, getInsuranceFeedback, FEEDBACK_NEGATIVE, FEEDBACK_POSITIVE };
